var addToMoodboardButton = document.querySelector('.add-to-moodboard-button');
var addToMoodboardLink = addToMoodboardButton === null || addToMoodboardButton === void 0 ? void 0 : addToMoodboardButton.querySelector('#addToMoodboardLink');
var addToMoodboardLinkText = addToMoodboardLink === null || addToMoodboardLink === void 0 ? void 0 : addToMoodboardLink.querySelector('p');
var moodboardAddLookButtonStyleChange = function () {
    addToMoodboardLinkText.innerText = Translator.trans('viewer.choose_moodboard');
    addToMoodboardButton.classList.add('add-to-moodboard-button-clicked');
    addToMoodboardButton.classList.remove('add-to-moodboard-button-hover');
    addToMoodboardButton.addEventListener('mouseleave', function () {
        addToMoodboardLink.style.opacity = '1';
    });
};
var moodboardAddLookButtonStyleRollBack = function () {
    addToMoodboardButton.classList.remove('add-to-moodboard-button-clicked');
    addToMoodboardButton.classList.remove('add-to-moodboard-button-added');
    addToMoodboardButton.classList.add('add-to-moodboard-button-hover');
    addToMoodboardButton.addEventListener('mouseenter', function () {
        addToMoodboardLink.style.opacity = '1';
    });
    addToMoodboardButton.addEventListener('mouseleave', function () {
        addToMoodboardLink.style.opacity = '0';
    });
    addToMoodboardLinkText.innerText = Translator.trans('viewer.save');
};
var moodboardAddLookButtonDone = function () {
    addToMoodboardButton.classList.add('add-to-moodboard-button-added');
    addToMoodboardButton.classList.remove('add-to-moodboard-button-clicked');
    addToMoodboardLinkText.innerText = Translator.trans('viewer.saved');
};
export { moodboardAddLookButtonStyleRollBack, moodboardAddLookButtonStyleChange, moodboardAddLookButtonDone };
